import React from "react";
import { useTable, useColumnOrder } from "react-table";
import Tooltip from "../_shared/components/Tooltip";

export default function Table2({ data }) {
  const columns = React.useMemo(
    () => [
      {
        Header: "Z Score Factors",
        columns: [
          {
            Header: "",
            accessor: "number",
          },
          {
            Header: "Market",
            accessor: "market",
          },
          {
            Header: "1Y Z-Score",
            accessor: "oneYZScore",
          },
          {
            Header: "3Y Z-Score",
            accessor: "threeYZScore",
          },
        ],
      },
    ],
    [],
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data }, useColumnOrder);

  function formatHeader(column, i) {
    const result = column.Header.split(" / ");
    if (i === 0) {
      return (
        <div style={{ display: "flex", padding: "20px", height: "74px" }}>
          <div>{result[0]}</div>
          <div
            data-tip={`The Z-Score is the number of standard deviations above or below a mean positioning value for a security over a specified period of time, which in the case of Longbow’s dashboard is 1 year and 3 years.
            By analyzing the raw positioning data, investors can see whether consensus is net long or short the position.  By analyzing the Z-Score, investors can identify the magnitude of that positioning.`}
            className="info-icon"
            style={{
              fontWeight: 100,
              color: "white",
              borderColor: "white",
              marginTop: 8,
            }}
          >
            i
          </div>
        </div>
      );
    } else if (["1Y Z-Score", "3Y Z-Score"].includes(result[0])) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            paddingBottom: "7px",
            marginTop: -13,
          }}
        >
          <div>
            <div style={{ textDecorationLine: "underline" }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              {result[0].split(" ")[0]}
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </div>
            <div>{result[0].split(" ")[1]}</div>
          </div>
        </div>
      );
    }
    return (
      <div
        style={{
          textAlign: "left",
          paddingBottom: 7,
          position: "relative",
          left: -21,
        }}
      >
        <div>
          <div>{result[0]}</div>
        </div>
      </div>
    );
  }

  function formatCell(cell, i) {
    if (i === 0) {
      return { textAlign: "center", width: "40px" };
    }
    if (i === 1) {
      return { position: "relative", textAlign: "left", left: -20 };
    }
    return { textAlign: "center", color: cell < 0 ? "#d33541" : "#5ec72e" };
  }

  return (
    <table {...getTableProps()}>
      <thead>
        {headerGroups.map((headerGroup, i) => {
          return (
            <tr
              className={i === 1 ? "border-bottom" : ""}
              {...headerGroup.getHeaderGroupProps()}
            >
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{formatHeader(column, i)}</th>
              ))}
            </tr>
          );
        })}
        <tr>
          <td>
            <Tooltip />
          </td>
        </tr>
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row, i) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map((cell, i) => {
                return (
                  <td
                    style={formatCell(cell.value, i)}
                    {...cell.getCellProps()}
                  >
                    {isNaN(cell.value)
                      ? cell.value
                      : i !== 0
                      ? parseFloat(cell.value).toLocaleString("en-US", {
                          maximumFractionDigits: 2,
                          minimumFractionDigits: 2,
                        })
                      : ""}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
